<template>
  <b-modal v-model="displayModal" centered hide-footer hide-header @hidden="onReset">
    <svg
      class="modal__close-icon"
      width="20"
      height="21"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      @click="onReset"
    >
      <path
        d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
        fill="#8E9CBB"
      />
      <path
        d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
        fill="#8E9CBB"
      />
    </svg>

    <div class="modal__title">
      {{ modalTitle }}
    </div>

    <div class="modal__input mb-0">
      <c-input
        v-model="name"
        :max-length="255"
        floating-label="Наименование категории"
        :clearable="true"
        :required="isSubmitted && nameError"
        :required-condition="isSubmitted && nameError"
        :class="{ 'required-field': isSubmitted && nameError }"
      />
    </div>

    <div class="modal__actions">
      <c-button
        size="large"
        class="modal__actions-reset"
        label="Отменить"
        @click="onReset"
      />
      <c-button
        class="modal__actions-save"
        label="Сохранить"
        color="primary"
        size="large"
        @click="onSubmit"
      />
    </div>
  </b-modal>
</template>

<script>
import Input from "@/components/controls2/Input";
import Button from "@/components/controls2/Button";

export default {
  name: "create-modal",
  components: {
    "c-input": Input,
    "c-button": Button,
  },
  data() {
    return {
      displayModal: false,
      id: false,
      name: "",
      isSubmitted: false,

      serverErrors: {
        name: "",
      },
    };
  },
  computed: {
    modalTitle() {
      if (!this.id) {
        return "Создать категорию";
      }
      return "Редактирование категории";
    },

    nameError() {
      if (this.serverErrors.name) return this.serverErrors.name;
      return this.name.trim() ? false : "Обязательное поле";
    },

    isValid() {
      return !this.nameError;
    },
  },

  watch: {
    name() {
      this.serverErrors.name = "";
    },
  },

  methods: {
    open(data) {
      if (data && data.id) {
        this.id = data.id;
        this.name = data.name;
      }

      this.displayModal = true;
    },

    getParams() {
      if (this.id)
        return {
          id: this.id,
          name: this.name,
        };

      return this.name;
    },

    onSubmit() {
      this.isSubmitted = true;

      if (!this.isValid) {
        return;
      }

      const action = this.id
        ? "referenceMoneySource/updateViolationGroup"
        : "referenceMoneySource/createViolationGroup";
      const params = this.getParams();

      this.$store
        .dispatch(action, params)
        .then(({ success }) => {
          if (success) {
            this.onReset();
            this.$emit('submitted');
          }
        })
        .catch((e) => {
          const { data } = e.response;
          const { name } = data.errors;
          
          if (name) {
            this.serverErrors.name = "Категория с таким названием уже добавлена в справочник";
          }
        });
    },

    onReset() {
      this.id = null;
      this.name = "";
      this.isSubmitted = false;
      this.serverErrors.name = "";
      this.displayModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars.scss";

.modal {
  &__close-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
  &__title {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 20px;

    @include onlyExtraSmall {
      font-size: 15px;
    }
  }
  &__input {
    margin-bottom: 25px;
    &.violation-input {
      display: flex;
      align-items: center;
      margin-bottom: 0;
    }
  }
  &__actions {
    margin-top: 40px;
    display: flex;
    justify-content: flex-end;

    & button {
      margin-left: 10px;
    }

    @include onlyExtraSmall {
      width: 100vw;
      margin-left: -20px;

      & button {
        width: 50%;
        border-radius: 0;
        margin-left: 0;
      }
    }
  }
}

::v-deep .modal-content {
  @include onlyExtraSmall {
    height: fit-content;
  }
}
::v-deep .modal-body {
  @include onlyExtraSmall {
    padding-bottom: 0;
  }
}
.mb-0 {
  margin-bottom: 0;
}
.required-field {
  margin-bottom: 20px;
}

::v-deep .c-input-required-text {
  white-space: normal !important;
}
</style>
